<template>
  <gjw-dialog
    :title="title"
    :show-dialog="dialogVisible"
    :config="{ showFooter, width: '800px' }"
    @close="closeDialog">
    <div>
      <div class="sub-title">
        <span>{{ subTitle }}</span>
      </div>
      <div>
        <gjw-table
          ref="listTable"
          v-loading="tableLoading"
          :columns="tableColumns"
          :list-data="tableData"
          :has-page="false"
        >
          <template #userNameSlot="{ row }">
            <span class="table-name">
              <img class="user-img" src="~@/assets/img/default-avstar.png" style="margin-right: 6px;">
              <span>{{ row.userName }}</span>
            </span>
          </template>
          <template #permissionTypeLabelSlot>
            <div>
              <span style="margin-right: 3px;">权限</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  可使用：仅可查看及下载、使用，不可修改云端文件内容（例如：上传、更新、重命名、移动等）
                  <br/>
                  可编辑：除修改权限外不限制操作
                </div>
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </div>
          </template>
          <template #permissionTypeSlot="{ row }">
            <div v-if="row.memberType !== 'CREATOR'">
              <el-tooltip v-if="getUserPermission" class="item" effect="dark" content="仅空间所有者支持操作" placement="top">
                <el-radio-group v-model="row.permissionType" :disabled="getUserPermission">
                  <el-radio label="USABLE">可使用</el-radio>
                  <el-radio label="EDITABLE">可编辑</el-radio>
                </el-radio-group>
              </el-tooltip>
              <el-radio-group v-else v-model="row.permissionType" :disabled="getUserPermission" @change="toggleVisibility($event, row, true)">
                <!-- 可使用 -->
                <el-popover
                  placement="top"
                  width="200"
                  trigger="manual"
                  v-model="row.usableVisible">
                  <div>
                    <i class="el-icon-warning" style="color: #FAAD14; margin-bottom: 15px; margin-right: 5px;"></i>
                    <span>是否确认修改权限？</span>
                  </div>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" @click="toggleVisibility(row.permissionType, row, false)">取消</el-button>
                    <el-button type="primary" size="mini" @click="handleModifyPermissionType(row.permissionType, row)">确定</el-button>
                  </div>
                  <el-radio slot="reference" label="USABLE">可使用</el-radio>
                </el-popover>
                <!-- 可编辑 -->
                <el-popover
                  placement="top"
                  width="200"
                  trigger="manual"
                  v-model="row.editadleVisible">
                  <div>
                    <i class="el-icon-warning" style="color: #FAAD14; margin-bottom: 15px; margin-right: 5px;"></i>
                    <span>是否确认修改权限？</span>
                  </div>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" @click="toggleVisibility(row.permissionType, row, false)">取消</el-button>
                    <el-button type="primary" size="mini" @click="handleModifyPermissionType(row.permissionType, row)">确定</el-button>
                  </div>
                  <el-radio slot="reference" label="EDITABLE">可编辑</el-radio>
                </el-popover>
              </el-radio-group>
            </div>
            <span v-else>所有者</span>
          </template>
        </gjw-table>
      </div>
    </div>
  </gjw-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { modifyErrorCodeMap } from '@/views/member/errorCodeMap.js'
export default {
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      permissionParmes: {},
      tableData: [],
      tableLoading: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'RESOURCE'
    },
    title: {
      type: String,
      default: '权限'
    },
    dialogVisible: {
      type: Boolean
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    subTitle: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
    tableColumns() {
      const allCols = [
        {
          type: 'slot',
          slotName: 'userNameSlot',
          label: '用户',
          prop: 'userName',
          minWidth: '160px',
        },
        {
          label: '手机号',
          prop: 'mobile',
          minWidth: '160px',
        },
        {
          type: 'slot',
          slotName: 'permissionTypeSlot',
          labelSlotName: 'permissionTypeLabelSlot',
          label: '权限',
          prop: 'permissionType',
          minWidth: '200px'
        }
      ]
      return allCols.filter((col) => {
        return col.showFn ? col.showFn() : true
      })
    },
    getUserPermission() {
      return this.userPermissionType !== 'CREATOR'
    }
  },
  methods: {
    init({ id, path }, object_type) {
      const object_ids = path?.split(',') || []
      object_ids.push(id)
      this.permissionParmes = {
        object_ids: object_ids.join(),
        object_id: id,
        object_type
      }
      this.getData()
    },
    async getData() {
      try {
        this.tableLoading = true
        this.tableData = await this.$api.member.getSpaceMembersPermissions(this.spaceId, { object_ids: this.permissionParmes.object_ids })
        this.userPermissionType = this.tableData.find((item) => item.userId === this.user.id)?.permissionType
        this.tableLoading = false
      } catch (err) {
        if (err.code === 'file.not.exist') {
          this.$message.error('文件不存在')
        }
      } finally {
        this.tableLoading = false
      }
    },
    toggleVisibility(val, row, status) {
      if (val === 'USABLE') {
        this.$set(row, 'usableVisible', status)
        !status && (row.permissionType = 'EDITABLE')
      } else if (val === 'EDITABLE') {
        this.$set(row, 'editadleVisible', status)
        !status && (row.permissionType = 'USABLE')
      }
    },
    // 修改成员权限
    async handleModifyPermissionType(val, row) {
      if (this.type === 'RESOURCE') {
        await this.$api.resource.hasResources(this.spaceId, this.permissionParmes.object_id)
        this.toggleVisibility(row.permissionType, row, true)
      } else {
        await this.$api.file.getFilePath(this.spaceId, this.permissionParmes.object_id)
        this.toggleVisibility(row.permissionType, row, true)
      }
      try {
        const params = {
          permission_type: val,
          object_id: this.permissionParmes.object_id,
          object_type: this.permissionParmes.object_type
        }
        const data = await this.$api.member.modifyPermission(this.spaceId, row.userIdStr, params)
        if (data) {
          this.$message.success('设置成功')
          this.$emit('success')
          row.usableVisible = false
          row.editadleVisible = false
        }
      } catch (err) {
        this.$matchError(err.code, modifyErrorCodeMap, '设置失败')
      } finally {
        row.usableVisible = false
        row.editadleVisible = false
      }
    },
    closeDialog() {
      this.$emit('close')
      this.tableData = []
    },
  }
}
</script>

<style lang="less" scoped>
.table-name {
  img {
    position: relative;
    top: 5px;
  }
}
.user-img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.sub-title {
  margin-bottom: 11px;
  color: #495f70;
}

.el-radio {
  margin-right: 30px;
  /deep/ .el-radio__label {
    font-size: 12px;
  }
}

</style>
